import { client } from 'shared/api';
import { clearAuth } from './tokens';

export const logout = (href = '/') => {
  client.resetStore();
  clearAuth();

  window.location.href = href;
};
